/**
 * Generuje domyślny szablon: czarny prostokąt z białą elipsą 80% rozmiaru materiału.
 * Rozdzielczość: 5 px/mm.
 */
export function generateDefaultTemplate(widthMm: number, heightMm: number): string {
  const ppm = 5;
  const w = Math.round(widthMm * ppm);
  const h = Math.round(heightMm * ppm);
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = '#000000';
  ctx.fillRect(0, 0, w, h);
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.ellipse(w / 2, h / 2, widthMm * 0.4 * ppm, heightMm * 0.4 * ppm, 0, 0, Math.PI * 2);
  ctx.fill();
  return canvas.toDataURL('image/png');
}

/**
 * Dopasowuje szablon do rozmiaru materiału.
 * Jeśli szablon jest mniejszy – uzupełnia czarnym (centruje).
 * Jeśli szablon jest większy – przycina (centruje + ramka 1 mm).
 * Zwraca nowy dataUrl PNG i nowe wymiary mm.
 */
export function fitTemplateToMaterial(
  tplDataUrl: string,
  tplWmm: number, tplHmm: number,
  matWmm: number, matHmm: number,
  addBorder: boolean = false,
): Promise<{ dataUrl: string; widthMm: number; heightMm: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // Użyj rozdzielczości wejściowego szablonu (px/mm)
      const ppm = img.width / tplWmm;
      const outW = Math.round(matWmm * ppm);
      const outH = Math.round(matHmm * ppm);
      const canvas = document.createElement('canvas');
      canvas.width  = outW;
      canvas.height = outH;
      const ctx = canvas.getContext('2d')!;
      // Czarne tło (padding gdy szablon mniejszy)
      ctx.fillStyle = '#000000';
      ctx.fillRect(0, 0, outW, outH);
      // Szablon wycentrowany (ujemne przesunięcie = przycięcie)
      const offX = (outW - img.width)  / 2;
      const offY = (outH - img.height) / 2;
      ctx.drawImage(img, offX, offY);
      // Ramka 1 mm (min 1 px) przy przycinaniu
      if (addBorder) {
        const b = Math.max(1, Math.round(ppm));
        ctx.fillStyle = '#000000';
        ctx.fillRect(0,        0,        outW, b);         // góra
        ctx.fillRect(0,        outH - b, outW, b);         // dół
        ctx.fillRect(0,        0,        b,    outH);      // lewa
        ctx.fillRect(outW - b, 0,        b,    outH);      // prawa
      }
      resolve({ dataUrl: canvas.toDataURL('image/png'), widthMm: matWmm, heightMm: matHmm });
    };
    img.onerror = reject;
    img.src = tplDataUrl;
  });
}
